module.exports = __webpack_public_path__ + "img/ic_setting.10891eb0.svg";